import { Injectable } from "@angular/core";
import { UserModel } from "../../models/user.model";
import { Subject } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable()
export class GlobalService {
  // Version
  public version: string = `Ver. ${environment.version}`;
  // User
  public user: UserModel = new UserModel();
  private User = new Subject<UserModel>();
  public $userViewer = this.User.asObservable();
  public loading: boolean = true;

  public overrideInstallRequirement: boolean = false;
  // public overrideLoginInstructions : boolean = false;

  public isInstalled: boolean = false;
  public isiOS: boolean = false;
  public device: string = "";
  public isMobile: boolean = false;
  public isNotificationRequried: boolean = true;

  public isConnected: boolean = true;

  SetUser(user: UserModel) {
    this.user = user;
    //NB: Save to storage if changed
    this.User.next(user);
  }

  GetUser() {
    return this.user;
  }

  getUserDomainID(): string {
    let domainID = "";
    if (this.user != undefined && this.user.username != undefined) {
      domainID = this.user.username.toLowerCase().replace("@santos.com", "");
    }
    return domainID;
  }

  ClearUser() {
    var user: UserModel = new UserModel();
    this.userLoggedIn = false;
    this.User.next(user);
  }

  //User logged in
  public userLoggedIn: boolean;
  SetUserLoggedIn(loggedIn: boolean) {
    this.userLoggedIn = loggedIn;
  }
}
